import React, { useState, useEffect } from 'react';
import '../css/Admin/SubscriptionPlan.css';
import Loading from '../general/Loading';
import { toast } from 'react-toastify';

const SubscriptionPlan = () => {
  const [plans, setPlans] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    plan_name: '',
    plan_code: '',
    description: '',
    price: '',
    offer_price: '',
    duration: '',
    trial_days: 7
  });

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.tradeintell.com/get-subscription-plan');
      if (response.ok) {
        const data = await response.json();
        setPlans(data);
      } else {
        console.error('Failed to fetch plans');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.plan_name || !formData.plan_code || !formData.description || !formData.price || !formData.offer_price || !formData.duration) {
      toast.error('Please fill all required fields.');
      return;
    }

    try {
      setLoading(true);

      const apiUrl = isEditMode 
        ? `https://api.tradeintell.com/edit-plan/${selectedPlan.id}` 
        : 'https://api.tradeintell.com/create-plan';

      const response = await fetch(apiUrl, {
        method: isEditMode ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
      }

      toast.success(isEditMode ? 'Plan updated successfully.' : 'New plan created.');
      setShowForm(false);
      setIsEditMode(false);
      setSelectedPlan(null);
      setFormData({
        plan_name: '',
        plan_code: '',
        description: '',
        price: '',
        offer_price: '',
        duration: '',
        trial_days: 7
      });

      fetchPlans(); // refresh the list
    } catch (error) {
      toast.error(error.message || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleManage = (plan) => {
    setShowForm(true);
    setIsEditMode(true);
    setSelectedPlan(plan);
    setFormData({
      plan_name: plan.plan_name,
      plan_code: plan.plan_code,
      description: plan.description,
      price: plan.price,
      offer_price: plan.offer_price,
      duration: plan.duration,
      trial_days: plan.trial_days || 7
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  
  return (
    <>
      <section className='my-4'>
        <div className='px-4'>
          <p className='page-heading'>Plans & Subscriptions</p>
          <p className='para-text text-muted'>Manage subscription plans and pricing to offer flexible options for users.</p>

          {!isEditMode && (
            <button className='about-btn mb-3' onClick={() => setShowForm(!showForm)}>
              {showForm ? 'CANCEL' : 'CREATE +'}
            </button>
          )}


          <div className="row mt-3">
                      {showForm && (
              <div className="col-lg-4 col-md-6 col-12 my-2">
                <div className="plan-card p-3">
                  <p className="page-heading text-light">{isEditMode ? 'Edit Plan' : 'Create New Plan'}</p>
                  <form onSubmit={handleSubmit} className='mt-3'>
                    <input
                      type="text"
                      name="plan_name"
                      placeholder="Plan Name*"
                      value={formData.plan_name}
                      onChange={handleChange}
                      className="contact-control bg-white"
                    />
                    <input
                      type="text"
                      name="plan_code"
                      placeholder="Plan Code* (e.g. PRO_MONTHLY)"
                      value={formData.plan_code}
                      onChange={handleChange}
                      className="contact-control bg-white"
                    />
                    <textarea
                      name="description"
                      placeholder="Plan Description*"
                      value={formData.description}
                      onChange={handleChange}
                      className="contact-control bg-white"
                      rows="3"
                    />
                    <input
                      type="number"
                      name="price"
                      placeholder="Price*"
                      value={formData.price}
                      onChange={handleChange}
                      className="contact-control bg-white"
                    />
                    <input
                      type="number"
                      name="offer_price"
                      placeholder="Offer Price*"
                      value={formData.offer_price}
                      onChange={handleChange}
                      className="contact-control bg-white"
                    />
                    <input
                      type="number"
                      name="duration"
                      placeholder="Duration (days)*"
                      value={formData.duration}
                      onChange={handleChange}
                      className="contact-control bg-white"
                    />
                    {/* <input
                      type="number"
                      name="trial_days"
                      placeholder="Trial Days"
                      value={formData.trial_days}
                      onChange={handleChange}
                      className="contact-control bg-white"
                    /> */}

                    <button
                      type="submit"
                      className="header-btn py-2 w-100 mt-3"
                      disabled={loading}
                    >
                      {loading ? 'Saving...' : isEditMode ? 'Update Plan' : 'Save'}
                    </button>
                  </form>
                </div>
              </div>
          )}


            {plans.length > 0 ? (
              plans.map((sp) => (
                <div className="col-lg-4 col-md-6 col-12 my-2" key={sp.id}>
                  <div className="plan-card p-3">
                    <p className='text-light fw-bold fm-inter'>
                      <span className='fs-2'>₹{sp.offer_price}</span> / 
                      <span className='para-text'>{sp.duration} days</span>
                      {sp.offer_price !== sp.price && (
                        <span className='ps-3 fs-5 text-decoration-line-through'>₹{sp.price}</span>
                      )}
                    </p>
                    <p className="page-heading">{sp.plan_name}</p>
                    <p className="fw-semibold">PLAN CODE: {sp.plan_code}</p>
                    <p>{sp.description}</p>
                    <p className='para-text fw-semibold'>{sp.trial_days} days trial available</p>

                    <button className='header-btn w-100 py-2' onClick={() => handleManage(sp)}>
                      Manage
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p>No Plans Created yet.</p>
            )}
          </div>
        </div>
      </section>

      {loading && <Loading setLoading={setLoading} />}
    </>
  );
};

export default SubscriptionPlan;
